import React from 'react';
import Modal, { useModal } from '../../Components/Modal';
import { useDoc } from '../../Data/Help';
import Text from '../../Components/Formatting/Text';
import Feedback from './Feedback';
import ButtonRow from '../../Components/Button/ButtonRow';
import Button from '../../Components/Button/Button';
import { isLocal, loadStylesheet, useNewWindow } from '../../Services/helpers';
import { PageLoading } from '../../Components/Loading';
import ButtonGap from '../../Components/Button/ButtonGap';

const Doc = ({docId, onClose, title}) => {
    const {doc, activityId} = useDoc(docId);

    return <Modal title={doc ? doc?.title : title} isOpen={!!docId} setIsOpen={onClose} dismissible>
        {doc ? <Inner {...{doc, activityId}} /> : <PageLoading />}
    </Modal>
}

const Inner = ({activityId, doc}) => {
    const newWindow = useNewWindow();
    const {closeModal} = useModal();

    loadStylesheet('fonts');

    return <>
        <div className="mt-2 text-left prose prose-sm inline-doc surface-1">
            <Text rich={doc ? doc.inline : ''} />
        </div>

        <ButtonRow>
            <Feedback activityId={activityId} short />
            <ButtonGap />
            <Button theme="light" label="Close" onClick={() => closeModal()} />
            <Button hide={!doc.full}
                theme="primary"
                label="More"
                icon="LinkExternal"
                onClick={() => newWindow(fullLink(doc))}
            />
        </ButtonRow>
    </>
}

const fullLink = (doc) => {
    const baseUrl = isLocal() ? 'http://localhost:8000/docs/' : 'https://getsoapy.com/docs/';
    return baseUrl + (doc.key.replace(/([A-Z])/g, '-$1').toLowerCase());
}

export default Doc;
